


























































import { FormField, FormOption } from '@ssp/inscreva-sse-models';
import { Component, Vue, Prop } from 'vue-property-decorator';
import 'vue-search-select/dist/VueSearchSelect.css';

const { MultiSelect, ModelSelect } = require('vue-search-select');

@Component({
  name: 'dynamic-form-option',
  components: {
    MultiSelect,
    ModelSelect,
    DynamicFormField: () => import('./DynamicFormField.vue'),
    DynamicFormOption: () => import('./DynamicFormOption.vue'),
  },
})
export default class DynamicFormOptionComponent extends Vue {
  @Prop({ default: true })
  private validate: boolean;

  @Prop({ default: false })
  private isEditing!: boolean;

  @Prop({ required: true })
  parent!: FormField | FormOption;

  @Prop({ required: true })
  options!: Array<FormOption>;

  get selected_option() {
    return this.parent.options && this.options.find((elm) => elm.id === (this.parent as FormOption).optionValue);
  }

  onSelect(items: Array<FormOption>) {
    (this.parent as FormOption).optionValue = items;
    const itemsIds = items.map(({ id }) => id);

    (this.parent as FormOption).options.forEach((option) => (option.value = !!itemsIds.includes(option.id)));
    this.$emit('on-select', items);
  }

  onModelSelect(item: any) {
    this.$emit('on-select', item);
  }

  get title(): string {
    return (this.parent as FormOption).optionText || this.parent.text;
  }

  onFieldButtonClick({ id, field }: { id: string; field: FormField }) {
    return this.$emit('on-field-button-click', { id, field });
  }
}
